/**
 * Handle product head actions
 *
 * @param {}
 * @return {void}
 */

$('.js-scroll-to').on('click', function(e) {
  e.preventDefault();

  const href = $(this).attr('href');
  const $container = $(href);

  if ($container.length == 0) {
    return;
  }

  let containerHeight = $container.offset().top;
  let headerHeight = $('.js-header').outerHeight();

  if (href == '#instant-price') {
    containerHeight = $container.parent().offset().top;
  }

  let scrollThisMuch = containerHeight

  $('html, body').animate({
    scrollTop: scrollThisMuch
  }, 600);
});



